<template>
<div id="info-popup">
    <span>{{description}}</span>
</div>
</template>

<script>
export default {
  name: 'InfoPopUp',
  props: {
    description: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
#info-popup {
  word-break: break-word;
  span {
    color: #828282;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/criteria_categories/InfoPopUp.vue